import React from "react";
import { createRoot } from "react-dom/client";
import Home from "./pages/index";

const App = () => <Home />;

createRoot(document.getElementById("root")!).render(<App />);
